import { render, staticRenderFns } from "./AbcPersonsForm.vue?vue&type=template&id=4dc689f6&scoped=true"
import script from "./AbcPersonsForm.vue?vue&type=script&lang=js"
export * from "./AbcPersonsForm.vue?vue&type=script&lang=js"
import style0 from "./AbcPersonsForm.vue?vue&type=style&index=0&id=4dc689f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc689f6",
  null
  
)

export default component.exports